import { Group, Badge, Text } from "@mantine/core";

const LabeledBadge = ({ icon, label, description, badgeColor = "#718096", badgeVariant = "light" }) => {
  return (
    <Group spacing="xs" align="flex-start" mb="sm">
      <Badge
        color={badgeColor}
        variant={badgeVariant}
        radius="sm"
        px={8}
        leftSection={icon}
        flex={3}
      >
        {label}
      </Badge>
      <Text size="sm" style={{ flex: 9 }}>
        {description || "No disponible"}
      </Text>
    </Group>
  );
};

export default LabeledBadge;